import { createFileRoute } from "@tanstack/react-router"

import { EmailPreviewPage } from "@/features/email-preview/payment-receipt-preview-page"
import { requireSuperAdminRouteAccess } from "@/features/authz/require-super-admin-route-access"

export const Route = createFileRoute("/dashboard/email/")({
	component: EmailPreviewPage,
	beforeLoad: async ({ context }) => {
		await requireSuperAdminRouteAccess(context.queryClient)
	},
})
